<div class="col-2 input-field" *ngFor="let caseMode of caseModes">
    <label [for]="'caseMode_' + caseMode.id">{{caseMode.name}}</label>
    <p-inputSwitch [inputId]="'caseMode_' + caseMode.id" [disabled]="disabled"
        [ngModel]="isSelected(caseMode.id)" (ngModelChange)="toggle(caseMode.id, $event)"
        [ngModelOptions]="{standalone: true}"></p-inputSwitch>
</div>
